import { validPass } from './utilFunctions';

export default (validation = validPass, id = '') => ({
	parentId: id,
	validate: null,
	input: '',
	neverValidated: true,
	validateResult: {
		valid: false,
		errorMessage: '',
		input: '',
	},

	isShowingError() {
		return !this.validateResult.valid && !this.neverValidated;
	},
	
	init() {
		this.$nextTick(() => {
			this.validate = {
				f: () => {
					const validateResult = validation(this.input);
					this.validateResult = validateResult;
					this.neverValidated = false;
					return this.validateResult;
				},
			};
		});
	},
	revalidate() {
		if (this.$event.detail.parentId === this.parentId) {
			this.validate.f();
		}
	}
});
